import { useCallback, useState } from 'react';
import { TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

import { Box } from '../../../components/UI/Box';
import { Flex } from 'src/components/UI/Flex';
import { Header } from 'src/components/Layout/Header';

import abstractBackground from 'src/assets/images/background.png';
import { PersonalData } from './PersonalData';
import { CreatePassword } from './CreatePassword';
import { useAssistantContext } from 'src/providers/AssistantProvider';
import { createSearchParams, useNavigate } from 'react-router-dom';

export enum TABS_INDEX {
  PERSONAL_DATA = 0,
  CREATE_PASSWORD = 1,
}

export function AssistantSignUp() {
  const [tabIndex, setTabIndex] = useState<TABS_INDEX>(TABS_INDEX.PERSONAL_DATA);
  const { createAssistantFormData } = useAssistantContext();

  const navigate = useNavigate();

  const handleChangeTab = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <Box
      w={'100%'}
      h={'100vh'}
      bg={'background'}
      overflowY={'auto'}
      backgroundSize={'cover'}
      backgroundRepeat={'no-repeat'}
      backgroundImage={{ base: '', sm: `url(${abstractBackground})` }}
    >
      <Header onGoBack={handleGoBack} />
      <Flex
        w={'100%'}
        flexDir={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
        p={{ base: '20px 20px 150px 20px', sm: '20px 20px' }}
      >
        <Flex
          w={{ base: '100%', sm: '450px' }}
          bg={{ base: 'background', sm: 'surface' }}
          borderRadius={'30px'}
          p={{ base: 0, sm: '50px' }}
          flexDir={'column'}
          mt={{ base: '26px', sm: '10px' }}
          boxShadow={{ base: 'none', sm: '12px 12px 40px rgba(61, 14, 107, 0.1)' }}
        >
          <Tabs isFitted index={tabIndex} variant={'unstyled'} mb={{ base: '106px', sm: 0 }} isLazy>
            <TabPanels>
              <TabPanel p={0} m={0}>
                <PersonalData
                  onNext={() => {
                    handleChangeTab(TABS_INDEX.CREATE_PASSWORD);
                  }}
                  tabClick={() => setTabIndex(TABS_INDEX.PERSONAL_DATA)}
                />
              </TabPanel>

              <TabPanel p={0} m={0}>
                <CreatePassword
                  onCreatAccount={() => {
                    navigate({
                      pathname: '/confirmaremail',
                      search: createSearchParams({
                        email: createAssistantFormData.email,
                      }).toString(),
                    });
                  }}
                  tabClick={() => setTabIndex(TABS_INDEX.PERSONAL_DATA)}
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Flex>
      </Flex>
    </Box>
  );
}
